import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
// import { useAtom } from 'jotai';

// import { loginAtom, renew_sign_in } from '../../lib/auth';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import QuizIcon from '@mui/icons-material/Quiz';

import {
  Avatar,
  Box,
  Tooltip,
} from '@mui/material';

import {
  Button,
  IconButton,
  Typography
} from '../../../../components/v2/styled';

import { Questionnaire } from '../../../../models/Questionnaire';

// import HelpersKnowledge from '../../../../actions/helpers/knowledge';

// const { DateTime } = require("luxon");

type Props = {
  questionnaire: Questionnaire;
  isSubject?: boolean;
  isCourse?: boolean;
  onClick?: () => void;
  sx?: any;
  play?: () => void;
  disabled?: boolean;
};

export const StyledKnowledgeQuiz: FunctionComponent<Props> = ({questionnaire, disabled, isSubject, isCourse, onClick, sx, play}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);

  return (<Box sx={{
    padding: 2,
    border: '1px solid transparent',
    borderColor: !!disabled ? 'lightgrey' : theme.palette.primary.main,
    borderRadius: 1,
    position: 'relative',
    paddingLeft: 10,
    // paddingRight: 12,
    ...sx
  }}>
    <Tooltip title={t(`coach.submenu.knowledge_attachment.lesson_content_titles.${!!isCourse ? 'course' : (!!isSubject ? 'subject' : 'lesson')}_quiz`)}><Avatar sx={{position: 'absolute', top: 8, left: 8, backgroundColor: !!disabled ? 'lightgrey' : theme.palette.tertiary?.main}}>
      <QuizIcon />
    </Avatar></Tooltip>
    {!!((questionnaire?.extra_data?.public_name || {})[i18n.resolvedLanguage || 'nl'] || questionnaire?.name) && <Typography variant="h5" sx={{
      ...(!!onClick ? {
        cursor: 'pointer'
      } : {}),
      ...(!!disabled ? {
        color: 'lightgrey'
      } : {})
    }} onClick={() => {
      if (!!onClick) onClick();
    }}>{(questionnaire?.extra_data?.public_name || {})[i18n.resolvedLanguage || 'nl'] || questionnaire?.name}</Typography>}
    {!((questionnaire?.extra_data?.public_name || {})[i18n.resolvedLanguage || 'nl'] || questionnaire?.name) && <Typography variant="h5" sx={{
      color: 'lightgrey',
      fontStyle:' italic',
      ...(!!onClick ? {
        cursor: 'pointer'
      } : {})
    }} onClick={() => {
      if (!!onClick) onClick();
    }}>{t("coach.submenu.knowledge_attachment.add_quiz")}</Typography>}
    
    {!!play && <Button
      label={t("client.course.actions.start_quiz")}
      id="start_lesson"
      color="primary"
      onClick={() => {
        if (!!play) play();
      }}
      startIcon={<PlayArrowIcon />}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        marginTop: 0,
        display: {
          xs: 'none',
          md: 'inline-flex'
        }
      }}
    />}
    {!!play && <IconButton
      color="primary"
      onClick={() => {
        if (!!play) play();
      }}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        marginTop: 0,
        display: {
          xs: 'inline-flex',
          md: 'none'
        },
        height: '42px'
      }}
    ><PlayArrowIcon /></IconButton>}
  </Box>);
}
